import Note from '../Note/Note';
import './NoteList.scss';
import PropTypes from 'prop-types';

// Common NoteList Component
const NoteList = ({ notes, modelName, movementType, refetchNotes, completed }) => {
  return (
    <div className="note_list_container">
      {notes?.map((note, index) => (
        <Note
          note={note}
          number={index + 1}
          key={note.id}
          refetchNotes={refetchNotes}
          movementType={movementType}
          modelName={modelName}
          completed={completed}
        />
      ))}
    </div>
  );
};

NoteList.propTypes = {
  notes: PropTypes.array,
  modelName: PropTypes.string,
  movementType: PropTypes.string,
  refetchNotes: PropTypes.func,
  completed: PropTypes.bool,
};

export default NoteList;
